import { render } from "./FolderInfo.vue?vue&type=template&id=3e5a7834&scoped=true"
import script from "./FolderInfo.vue?vue&type=script&lang=js"
export * from "./FolderInfo.vue?vue&type=script&lang=js"

import "./FolderInfo.vue?vue&type=style&index=0&id=3e5a7834&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e5a7834"]])

export default __exports__